<app-header [headerStep]="headerStep" [local]="true"></app-header>
<app-resume-step></app-resume-step>

<div class="flex flex-col container mx-auto mb-6 gap-4" *ngIf="questions">
  <h2
    class="text-text font-bold text-lg text-center mt-8"
    [innerHTML]="
      customerExperience ? resource.crossselling.title_w : resource.crossselling.title_c
    "></h2>

  <div class="container mx-auto mb-6">
    <form [formGroup]="form" class="" *ngIf="!isPartner()">
      <div *ngIf="questions.length > 0">
        <div *ngFor="let question of questions; let i = index" class="space-y-5">
          <app-question [question]="question" [local]="true"></app-question>
          <app-toggle-question
            [responses]="question.responseVMs ?? []"
            [reduced]="true"
            formControlName="question-{{ question.id }}"></app-toggle-question>
        </div>
      </div>

      <div class="w-full md:col-span-2 consent space-y-4 my-10">
        <div class="flex items-center justify-items">
          <div class="basis-5/6 mr-1">
            <p class="text-[16px]" [innerHTML]="resource.consent.marketing_email"></p>
          </div>
          <div class="basis-1/6 text-right">
            <p-inputSwitch formControlName="marketing_email_opposition"></p-inputSwitch>
          </div>
        </div>
        <div class="flex items-center justify-items">
          <div class="basis-5/6 mr-1">
            <p class="text-[16px]" [innerHTML]="resource.consent.marketing_phone"></p>
          </div>
          <div class="basis-1/6 text-right">
            <p-inputSwitch formControlName="marketing_phone_consent"></p-inputSwitch>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div>
    <p
      class="p-error text-center mb-2"
      *ngIf="form.invalid && triedSubmit"
      [innerHTML]="resource.error.crossSelling"></p>
  </div>
  <button
    *ngIf="!hideSubmitButton"
    pButton
    type="button"
    class="button-NS w-full"
    title="{{ resource.form.validate }}"
    [label]="resource.form.validate"
    [loading]="isLoading"
    [disabled]="isLoading"
    (click)="validateQuestions()"></button>
  <div
    *ngIf="hideSubmitButton"
    class="button-noline w-full text-success"
    [innerHTML]="resource.crossselling.answers_saved"></div>

  <div class="container mx-auto h-28 md:h-40">
    <app-footer class="footer"></app-footer>
  </div>
  <app-web-callback></app-web-callback>
</div>
